"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = require("react");

var _material = require("@mui/material");

var _Icon = require("../Icon");

var _theme = require("../../theme");

var _utilities = require("../../utilities");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["disabled", "label", "iconLeft", "iconLeftColor", "iconLeftStyle", "iconRight", "iconRightColor", "iconRightStyle", "isBusy", "isDone", "size", "type", "variant"];

var _$concat$concat, _$concat$concat2, _$concat$concat3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// Since the complete and loading states are disabled but don't show the disabled css
// we have to override the styles here for the (non-loading, non-complete) disabled state.
var variants = {
  contained: (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiButton.contained, ".").concat(_utilities.classes.states.MuiDisabled), (_$concat$concat = {}, (0, _defineProperty2.default)(_$concat$concat, "& .".concat(_utilities.classes.components.MuiBox.root), {
    opacity: "60%"
  }), (0, _defineProperty2.default)(_$concat$concat, "backgroundColor", _theme.palette.primary.light), (0, _defineProperty2.default)(_$concat$concat, "borderColor", _theme.palette.primary.light), (0, _defineProperty2.default)(_$concat$concat, "color", _theme.palette.primary.main), (0, _defineProperty2.default)(_$concat$concat, "cursor", "not-allowed"), (0, _defineProperty2.default)(_$concat$concat, "pointerEvents", "initial"), _$concat$concat)),
  outlined: (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiButton.outlined, ".").concat(_utilities.classes.states.MuiDisabled), (_$concat$concat2 = {}, (0, _defineProperty2.default)(_$concat$concat2, "& .".concat(_utilities.classes.components.MuiBox.root), {
    opacity: "60%"
  }), (0, _defineProperty2.default)(_$concat$concat2, "backgroundColor", _theme.palette.brand.grey.lightGrey), (0, _defineProperty2.default)(_$concat$concat2, "borderColor", _theme.palette.brand.grey.lightGrey), (0, _defineProperty2.default)(_$concat$concat2, "color", _theme.palette.brand.grey.charcoal), (0, _defineProperty2.default)(_$concat$concat2, "cursor", "not-allowed"), (0, _defineProperty2.default)(_$concat$concat2, "pointerEvents", "initial"), _$concat$concat2)),
  text: (0, _defineProperty2.default)({}, "&.".concat(_utilities.classes.components.MuiButton.text, ".").concat(_utilities.classes.states.MuiDisabled), (_$concat$concat3 = {}, (0, _defineProperty2.default)(_$concat$concat3, "& .".concat(_utilities.classes.components.MuiBox.root), {
    opacity: "60%"
  }), (0, _defineProperty2.default)(_$concat$concat3, "color", _theme.palette.brand.grey.charcoal), (0, _defineProperty2.default)(_$concat$concat3, "cursor", "not-allowed"), (0, _defineProperty2.default)(_$concat$concat3, "pointerEvents", "initial"), _$concat$concat3))
};
var StyledMuiButton = (0, _material.styled)(_material.Button)(function (_ref) {
  var disabled = _ref.disabled,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "contained" : _ref$variant;
  return disabled && _objectSpread({}, variants[variant]);
});
var TextButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      label = _ref2.label,
      iconLeft = _ref2.iconLeft,
      iconLeftColor = _ref2.iconLeftColor,
      iconLeftStyle = _ref2.iconLeftStyle,
      iconRight = _ref2.iconRight,
      iconRightColor = _ref2.iconRightColor,
      iconRightStyle = _ref2.iconRightStyle,
      _ref2$isBusy = _ref2.isBusy,
      isBusy = _ref2$isBusy === void 0 ? false : _ref2$isBusy,
      _ref2$isDone = _ref2.isDone,
      isDone = _ref2$isDone === void 0 ? false : _ref2$isDone,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "medium" : _ref2$size,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? "button" : _ref2$type,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? "contained" : _ref2$variant,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledMuiButton, _objectSpread(_objectSpread({
    "aria-label": label,
    disabled: isDone || isBusy || disabled,
    ref: ref,
    role: rest.to || rest.href ? "link" : "button",
    size: size,
    type: type,
    variant: variant
  }, rest), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      height: "12px",
      position: "absolute",
      children: [isBusy && !isDone && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.CircularProgress, {
        color: "inherit",
        size: "0.75rem",
        thickness: 5
      }), isDone && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        iconName: "check",
        size: "small"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.Box, {
      visibility: isBusy || isDone ? "hidden" : "visible",
      children: [iconLeft && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: iconLeftColor,
        iconName: iconLeft,
        iconStyle: iconLeftStyle,
        mr: 1,
        size: "small"
      }), label, iconRight && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: iconRightColor,
        iconName: iconRight,
        iconStyle: iconRightStyle,
        ml: 1,
        size: "small"
      })]
    })]
  }));
});
var _default = TextButton;
exports.default = _default;